import { action } from "mobx";
import { Observer } from "mobx-react";
import React, { useContext } from "react";
import { redirect } from "../../WSUtils/urlUtils";
import { UserInfoContext } from "../../WSUtils/UserInfoContext";
import { CVPSearchParams } from "../../WSUtils/wsQueryStringStore";
import { Steps } from "../Steps/Steps";
import { CVEditContext } from "./CVEditContext";

export const CVEditStepSelector = () => {
  const cvEditContext = useContext(CVEditContext);
  const userInfo = useContext(UserInfoContext);

  return (
    <Observer
      render={() => {
        return (
          <Steps
            className="cve-steps"
            value={cvEditContext.currentStep}
            steps={cvEditContext.steps}
            onChange={action((evt, value) => {
              const stepIndex = cvEditContext.steps.indexOf(value);

              redirect(null, {
                userInfo,
                mergeQs: {
                  [CVPSearchParams.cvpstep]: (stepIndex + 1).toString(),
                },
              });
            })}
          />
        );
      }}
    />
  );
};
